import { useCallback } from "react";
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { apiRequest } from "../config/authConfig";

const API_ROOT = process.env.REACT_APP_API_ROOT;

/**
 * Returns an apiFetch(path, options) function bound to the current MSAL account.
 * Acquires an API access token silently (falling back to popup on interaction-required),
 * attaches it as a Bearer header, and calls fetch against API_ROOT + path.
 *
 * `path` may be an absolute URL or a path like "/user".
 */
export function useApiFetch() {
  const { instance, accounts } = useMsal();

  return useCallback(
    async (path, options = {}) => {
      const account = accounts[0];
      if (!account) throw new Error("Not signed in");

      let token;
      try {
        const result = await instance.acquireTokenSilent({ ...apiRequest, account });
        token = result.accessToken;
      } catch (err) {
        if (err instanceof InteractionRequiredAuthError) {
          const result = await instance.acquireTokenPopup({ ...apiRequest, account });
          token = result.accessToken;
        } else {
          throw err;
        }
      }

      const url = /^https?:\/\//i.test(path) ? path : `${API_ROOT}${path.startsWith("/") ? path : "/" + path}`;
      const headers = {
        ...(options.headers || {}),
        Authorization: `Bearer ${token}`
      };
      return fetch(url, { ...options, headers });
    },
    [instance, accounts]
  );
}
